import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit {
  paginator: boolean;
  @Input() paginationObj: any;
  @Output() pagination = new EventEmitter();
  @ViewChild(MatPaginator) paginatorEvent: MatPaginator;
  constructor() { }

  ngOnChanges() {
    if(this.paginationObj.changed){
      if (this.paginatorEvent) {
        this.paginatorEvent.firstPage();
      }
    }
    
  }
  ngOnInit(): void {
  }
  onPaginatorShow (){
    this.paginator = !this.paginator
    console.log(this.paginator )
  }

  handlePageEvent(event) {
    this.pagination.emit(event);
  }

}
